export const getPageTitle = (title?: string): string => {
  const appTitle = window.location.host.startsWith("resident")
    ? "CoverTree Residents Portal"
    : "CoverTree Maple";

  if (title) {
    return `${appTitle} | ${title}`;
  }

  return appTitle;
};
